// Convenience export
export * as Routes from '@account/constants/routes';

// routePath populates parameter values in a route path
// (so it turns :contractId into the actual ID, for example)
const routePath = (route, params) => {
  if (!route) {
    throw new Error('Unknown route');
  }

  const variables = [...route.matchAll(/:([^/]+)/g)].map(
    variable => variable[1]
  );

  return variables.reduce(
    (path, variable) =>
      Object.keys(params).includes(variable) // only replace it if it's in the params list
        ? path.replace(`:${variable}`, params[variable])
        : path,
    route
  );
};

export default routePath;
